import api from "@/api";
var HELP_BASE;
var WEBHOOK_BASE;
var APPLICATION_WEBHOOK_BASE;
var CHANNEL_WEBHOOK_BASE;
var SERVER_WEBHOOK_BASE;
var LS_BASE = "https://www.liveswitch.io";
var ext;
if (api.props.config.environment == "prod") {
  ext = "";
} else if (api.props.config.environment == "rc") {
  ext = "-rc";
} else if (api.props.config.environment == "beta") {
  ext = "-beta";
} else {
  ext = "-nightly";
}
HELP_BASE = "http://frznmtn.com/cloud-docs" + ext;
WEBHOOK_BASE = "http://frznmtn.com/cloud-webhooks" + ext;
APPLICATION_WEBHOOK_BASE = "http://frznmtn.com/cloud-application-webhooks" + ext;
CHANNEL_WEBHOOK_BASE = "http://frznmtn.com/cloud-channel-webhooks" + ext;
SERVER_WEBHOOK_BASE = "http://frznmtn.com/cloud-server-webhooks" + ext;

export default {
  documentationBase: `${HELP_BASE}`,
  liveswitchBase: `${LS_BASE}`,
  apiKeys: { link: `${HELP_BASE}#api-keys` },
  liveswitch: {
    contact: { link: `${LS_BASE}/contact` }
  },
  applicationConfig: {
    link: `${HELP_BASE}#application-configuration`,
    tag: { link: `${HELP_BASE}#name` },
    applicationId: { link: `${HELP_BASE}#application-id` },
    gatewayURL: { link: `${HELP_BASE}#gateway-url` },
    sharedSecret: { link: `${HELP_BASE}#shared-secret` },
    webhookConfig: { link: `${HELP_BASE}#webhook-configuration` },
  },
  channelConfig: {
    link: `${HELP_BASE}#channel-overrides-configuration`,
    audioCodecs: { link: `${HELP_BASE}#audio-codecs` },
    videoCodecs: { link: `${HELP_BASE}#video-codecs` },
    recordingConfig: { link: `${HELP_BASE}#recording-configuration` },
    SFUConfiguration: { link: `${HELP_BASE}#sfu-configuration` },
    MCUConfiguration: { link: `${HELP_BASE}#mcu-configuration` },
    rtmp: { link: `${HELP_BASE}#rtmp` },
    webhookConfig: { link: `${HELP_BASE}#webhook-configuration` },
  },
  dashboard: { link: `${HELP_BASE}#dashboard` },
  downloads: { link: `${HELP_BASE}#downloads` },
  recordings: { link: `${HELP_BASE}#recordings`},
  sessions: { link: `${HELP_BASE}#sessions` },
  subscription: { link: `${HELP_BASE}#subscription` },
  webhooks: {
    base: { link: `${WEBHOOK_BASE}` },
    application: {
      base: { link: `${APPLICATION_WEBHOOK_BASE}` },
      clientRegistered: {
        link: `${APPLICATION_WEBHOOK_BASE}#client-registered`,
      },
      clientUnregistered: {
        link: `${APPLICATION_WEBHOOK_BASE}#client-unregistered`,
      },
      clientUpdated: {
        link: `${APPLICATION_WEBHOOK_BASE}#client-updated`,
      },
      clientMessage: { link: `${APPLICATION_WEBHOOK_BASE}#client-message` },
      serverMessage: {
        link: `${APPLICATION_WEBHOOK_BASE}#server-message`,
      },
    },
    channel: {
      base: { link: `${CHANNEL_WEBHOOK_BASE}` },
      clientJoined: { link: `${CHANNEL_WEBHOOK_BASE}#client-joined` },
      clientLeft: { link: `${CHANNEL_WEBHOOK_BASE}#client-left` },
      clientMessage: { link: `${CHANNEL_WEBHOOK_BASE}#client-message` },
      connectionInitializing: {
        link: `${CHANNEL_WEBHOOK_BASE}#connection-initializing`,
      },
      connectionConnecting: {
        link: `${CHANNEL_WEBHOOK_BASE}#connection-connecting`,
      },
      connectionConnected: {
        link: `${CHANNEL_WEBHOOK_BASE}#connection-connected`,
      },
      connectionVideoReady: { link: `${CHANNEL_WEBHOOK_BASE}#connection-video-ready` },
      connectionAudioReady: { link: `${CHANNEL_WEBHOOK_BASE}#connection-audio-ready` },
      channelVideoReady: { link: `${CHANNEL_WEBHOOK_BASE}#channel-video-ready` },
      connectionsReady: { link: `${CHANNEL_WEBHOOK_BASE}#connections-ready` },
      channelAudioReady: { link: `${CHANNEL_WEBHOOK_BASE}#channel-audio-ready` },
      channelReady: { link: `${CHANNEL_WEBHOOK_BASE}#channel-ready` },
      channelExpired: { link: `${CHANNEL_WEBHOOK_BASE}#channel-expired` },
      connectionUpdated: { link: `${CHANNEL_WEBHOOK_BASE}#connection-updated` },
      connectionClosing: { link: `${CHANNEL_WEBHOOK_BASE}#connection-closing` },
      connectionClosed: { link: `${CHANNEL_WEBHOOK_BASE}#connection-closed` },
      connectionFailing: { link: `${CHANNEL_WEBHOOK_BASE}#connection-failing` },
      connectionFailed: { link: `${CHANNEL_WEBHOOK_BASE}#connection-failed` },
      connectionStats: { link: `${CHANNEL_WEBHOOK_BASE}#connection-stats` },
      channelActivated: { link: `${CHANNEL_WEBHOOK_BASE}#channel-activated` },
      channelDeactivated: {
        link: `${CHANNEL_WEBHOOK_BASE}#channel-deactivated`,
      },
      rtmpStarted: {
        link: `${CHANNEL_WEBHOOK_BASE}#rtmp`,
      },
      rtmpStopped: {
        link: `${CHANNEL_WEBHOOK_BASE}#rtmp`,
      },
      serverMessage: {
        link: `${CHANNEL_WEBHOOK_BASE}#server-message`,
      },
    },
    server: {
      base: { link: `${SERVER_WEBHOOK_BASE}` },
    }
  }
};
